// extracted by mini-css-extract-plugin
export default {"menu":"Searchbar_menu__5P-vT","inner":"Searchbar_inner__B4TVd","searchContainer":"Searchbar_searchContainer__xppqN","menuLink":"Searchbar_menuLink__KslLA"};